import { render, staticRenderFns } from "./PreviousCompetitionsMain.vue?vue&type=template&id=38d7a9be&scoped=true"
import script from "./PreviousCompetitionsMain.vue?vue&type=script&lang=js"
export * from "./PreviousCompetitionsMain.vue?vue&type=script&lang=js"
import style0 from "./PreviousCompetitionsMain.vue?vue&type=style&index=0&id=38d7a9be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d7a9be",
  null
  
)

export default component.exports